import ModelBaseClass from "@quasidea/oas-client-react/lib/ModelBaseClass";
import CashAccountOffageDetails from "../CashAccountOffageDetails";
import ModelProxyClass from "./ModelProxyClass";


/**
 * @class CashAccountOffageDetailsBase
 * @extends ModelBaseClass
 * @property {'Handpay'|'BatchDiscrepancy'|'ProcessDiscrepancy'|'VgtMeterAdjustment'|'RamClear'} type
 * @property {number} trackingCashAccount (integer) Handpay: null.  BatchDiscrepancy: set to the Vault.  ProcessDiscrepancy: set to the VGT or RT MachineRecord that the collection came from.  VgtMeterAdjustment: set to the VGT MachineRecord.  RamClear: set to the VGT MachineRecord
 * @property {number} trackingLocation (integer) Handpay: set to the location.  BatchDiscrepancy: null.  ProcessDiscrepancy: set to the location that the collection came from.  VgtMeterAdjustment: set to the location of the VGT.  RamClear: set to the location of the VGT.
 */
class CashAccountOffageDetailsBase extends ModelBaseClass {
	/**
	 * @type {'Handpay'|'BatchDiscrepancy'|'ProcessDiscrepancy'|'VgtMeterAdjustment'|'RamClear'} type
	 */
	type;
	/**
	 * Handpay: null.  BatchDiscrepancy: set to the Vault.  ProcessDiscrepancy: set to the VGT or RT MachineRecord that the collection came from.  VgtMeterAdjustment: set to the VGT MachineRecord.  RamClear: set to the VGT MachineRecord
	 * @type {number} trackingCashAccount (integer)
	 */
	trackingCashAccount;
	/**
	 * Handpay: set to the location.  BatchDiscrepancy: null.  ProcessDiscrepancy: set to the location that the collection came from.  VgtMeterAdjustment: set to the location of the VGT.  RamClear: set to the location of the VGT.
	 * @type {number} trackingLocation (integer)
	 */
	trackingLocation;

	/**
	 * Instantiates a new instance of CashAccountOffageDetails based on the generic object being passed in (typically from a JSON object)
	 * @param {object} genericObject
	 * @return {CashAccountOffageDetails}
	 */
	static create(genericObject) {
		const newCashAccountOffageDetails = new CashAccountOffageDetails();
		newCashAccountOffageDetails.instantiate(_modelDefinition, genericObject, ModelProxyClass.createByClassName);
		return newCashAccountOffageDetails;
	}

	/**
	 * Instantiates a new array of CashAccountOffageDetails based on the generic array being passed in (typically from a JSON array)
	 * @param {[object]} genericArray
	 * @return {[CashAccountOffageDetails]}
	 */
	static createArray(genericArray) {
		if (genericArray === null) {
			return null;
		}

		const newCashAccountOffageDetailsArray = [];
		genericArray.forEach(genericObject => {
			newCashAccountOffageDetailsArray.push(CashAccountOffageDetails.create(genericObject));
		});
		return newCashAccountOffageDetailsArray;
	}
}

const _modelDefinition = [
	ModelBaseClass.createModelProperty('type', 'string'),
	ModelBaseClass.createModelProperty('trackingCashAccount', 'integer'),
	ModelBaseClass.createModelProperty('trackingLocation', 'integer'),
];

export default CashAccountOffageDetailsBase;
